import React from 'react';
import styled from 'styled-components';

const Img = styled.img`
	max-width: 100%;
	height: auto;
	padding: 0 3px;
`;
export default ({ src, alt, width = '16', height = '16', title }) => (
	<Img loading="lazy" src={src} alt={alt} title={title} width={width} height={height} />
);
